module.exports = __webpack_public_path__ + "img/goals_card.9a8f7952.svg";